import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import React from "react";
import Lang from "./Lang";


export default function HTRadioGroup({list, value, setValue, label=undefined}) {

    const handleChange = (event) => {
      setValue(event.target.value);
    };

return (
  <FormControl>
        <FormLabel id="demo-radio-buttons-group-label">{label ? <Lang w={label} /> : ""}</FormLabel>
    <RadioGroup
      aria-labelledby="demo-radio-buttons-group-label"
      value={value}
      onChange={handleChange}
        >
            {list.map(item => <FormControlLabel value={item._id} control={<Radio />} label={item.name} />)}
     
     
    </RadioGroup>
  </FormControl>
);
}